import React, { Fragment } from "react";

const CompanyImageDescriptionItem = ({ episode: { currentepisode } }) => {
  return (
    <Fragment>
      <div className="selected-week-image-container">
        <img
          src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/employer_spotlight_images/${currentepisode.companyimage}`}
          className="selected-industry-company-image"
          alt="imagedescription"
        />
      </div>
      <div className="weekly-description">
        <div className="flex-center">
          <p className="weekly-title">
            {currentepisode && currentepisode.companydescriptionname}
          </p>
        </div>
        <p className="weekly-paragraph" id="green-scroll">
          {currentepisode && currentepisode.description}
        </p>
      </div>
    </Fragment>
  );
};

export default CompanyImageDescriptionItem;
